import consumer from "./consumer";

const appChannelSubscriptions = {};
// console.log("🔥 appChannel loaded!");


export function subscribeToAppChannel(streamKey = "global", callback) {
  if (appChannelSubscriptions[streamKey]) {
    console.warn(`Already subscribed to AppChannel (${streamKey})`);
    return appChannelSubscriptions[streamKey];
  }

  const subscription = consumer.subscriptions.create(
    { channel: "AppChannel", stream: streamKey },
    {
      connected() {
        console.log(`Connected to AppChannel (${streamKey})`);
      },

      disconnected() {
        console.log(`Disconnected from AppChannel (${streamKey})`);
      },

      received(data) {
        if (typeof callback === "function") callback(data);
      }
    }
  );

  // Save subscription
  appChannelSubscriptions[streamKey] = subscription;

  return subscription;
}

export function unsubscribeFromAppChannel(streamKey = "global") {
  const subscription = appChannelSubscriptions[streamKey];

  if (subscription) {
    consumer.subscriptions.remove(subscription);
    delete appChannelSubscriptions[streamKey];
    console.log(`Unsubscribed from AppChannel (${streamKey})`);
  }
}

window.subscribeToAppChannel = subscribeToAppChannel;
window.unsubscribeFromAppChannel = unsubscribeFromAppChannel;
